import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setResetCases } from '../../../redux/cases'
import { stepReset } from '../../../redux/steps'
import CheckIcon from '../../../assets/icons/check_bg_green.svg'
import {
  Container,
  SuccessImage,
  SuccessWrapper,
  SuccesImageWrapper,
  SuccessTitle,
  SubtitleSection,
  SuccessSubTitle,
  ButtonsWrapper,
  Button
} from '../CaseSendedNotReferible/styles'
import './styles'
import { PatientAccessMessage } from '../PatientAccessMessage'

export function CaseSendedNonReferableReferred () {
  const dispatch = useDispatch()
  const history = useHistory()

  const handleResetCase = () => {
    dispatch(setResetCases())
    dispatch(stepReset())
  }

  const handleGoToHome = () => {
    history.replace('/home')
    handleResetCase()
  }

  return (
    <Container>
      <SuccessWrapper>
        <SuccesImageWrapper>
          <SuccessImage src={CheckIcon} alt='success' />
        </SuccesImageWrapper>

        <SuccessTitle> Estudio referido a oftalmólogo </SuccessTitle>

        <SubtitleSection>
          <SuccessSubTitle>
            La IA no detectó signos compatibles con la retinopatía diabética, pero usted ha decidido referir el estudio a un oftalmólogo, por lo que él mismo fue enviado con éxito a un oftalmólogo especialista en retina.<br />
            <PatientAccessMessage /><br />
            En cuanto el estudio sea informado, recibirá una notificación también por mail, y podrá acceder al informe profesional detallado.<br />
            Le enviaremos un recordatorio dentro de 10 meses para que vuelva a repetir el control.<br />
          </SuccessSubTitle>
        </SubtitleSection>

        <ButtonsWrapper>
          <Button onClick={handleGoToHome}> Volver al inicio </Button>
          <Button highlighted onClick={handleResetCase}> Realizar nuevo estudio </Button>
        </ButtonsWrapper>
      </SuccessWrapper>
    </Container>
  )
}

export default CaseSendedNonReferableReferred
